import { Injectable, Injector } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpErrorResponse,
  HttpResponse,
  HttpClient,
} from "@angular/common/http";
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { AuthService } from "./auth.service";
// import { CookieService } from 'ngx-cookie-service';
import { HttpService, UtilityService } from "services";
import { LogsService } from "./log.service";

const MINUTES_UNITL_AUTO_LOGOUT = 30; // in mins
const CHECK_INTERVAL = 30000; // in ms
const STORE_KEY = "actvt";

@Injectable()
export class HTTPStatus {
  public requestInFlight$: BehaviorSubject<boolean>;
  constructor() {
    this.requestInFlight$ = new BehaviorSubject(false);
  }

  setHttpStatus(inFlight: boolean) {
    this.requestInFlight$.next(inFlight);
  }
}

@Injectable({
  providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
  private reqTrigger: boolean = false;
  constructor(
    private injector: Injector,
    private status: HTTPStatus,
    private util: UtilityService,
    private httpService: HttpService,
    private logs: LogsService
  ) {
    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(STORE_KEY, Date.now().toString());
  }

  authService = this.injector.get(AuthService);

  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY), 10);
  }

  public setLastAction(lastAction: number) {
    if (localStorage.getItem("token")) {
      localStorage.setItem(STORE_KEY, lastAction.toString());
    }
  }

  initListener() {
    if (localStorage.getItem("token")) {
      document.body.addEventListener("click", () => this.reset());
      document.body.addEventListener("mouseover", () => this.reset());
      document.body.addEventListener("mouseout", () => this.reset());
      document.body.addEventListener("keydown", () => this.reset());
      document.body.addEventListener("keyup", () => this.reset());
      document.body.addEventListener("keypress", () => this.reset());
    }
  }

  reset() {
    this.setLastAction(Date.now());
  }
  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }
  check() {
    if (localStorage.getItem("token")) {
      const now = Date.now();
      const timeleft =
        this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
      const diff = timeleft - now;
      const isTimeout = diff < 0;

      if (isTimeout) {
        localStorage.clear();
        window.location.reload();
      }
    }
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  decodeToken() {
    return btoa(`${this.util.getUser()}:${localStorage.getItem("token")}`);
  }
  getSessionId() {
    return localStorage.getItem("sessionId");
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers = new HttpHeaders();
    let clone;

    this.status.setHttpStatus(true);
    const authService = this.injector.get(AuthService);
    const contentType = "application/json";
    headers =
      authService.loggedIn() && !req.headers.get("skip")
        ? req.url.includes("gis.sbmurban.org")
          ? headers.set("Authorization", "Basic " + this.decodeToken())
          : headers
              .set("Authorization", "Basic " + this.decodeToken())
              .set("SessionId", this.getSessionId())
        : headers;
    
      // headers =
      //   authService.loggedIn() && !req.headers.get("skip") ? headers.set("Authorization", "Basic " + this.decodeToken())  : headers;

    if (req.body instanceof FormData) {
      clone = req.clone({ headers });
    } else {
      headers = headers.set("content-type", contentType);
      clone = req.clone({ headers });
    }

    return next.handle(clone).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          this.reqTrigger = true;
          if (this.reqTrigger && !req.url.includes("logs")) {
            this.httpService.setIntercepterLogsData(req).subscribe((r1) => {
              this.reqTrigger = false;
            });
          }
        }
        return event;
      }),
      catchError(this.handleError),
      finalize(() => {
        this.status.setHttpStatus(false);
      })
    );
  }
}
// const authService = this.injector.get(AuthService);
//     headers = authService.loggedIn ? headers.append('Authorization',
//       'Basic ' + btoa(`${localStorage.getItem('user')}:${localStorage.getItem('token')}`)) : headers;
